import { baseUrl } from 'volto-ebc-radionacional/utils/api';
import { normalizeLatestAudioUrl } from '../../utils/normalizeLatestAudioUrl';

export type LatestContentItem = {
  '@id': string;
  audio?: string | null;
  datePublished?: string;
  image?: string | null;
  pogramTitle?: string;
  programUrl?: string;
  title?: string;
};

export function normalizeLatestContent(data: unknown): LatestContentItem[] {
  return (Array.isArray(data) ? data : []).map((item: LatestContentItem) => ({
    ...item,
    audio: normalizeLatestAudioUrl(item.audio, item['@id']),
  }));
}

export async function getLatestContent(page = 1): Promise<LatestContentItem[]> {
  try {
    const url =
      page > 1
        ? `${baseUrl}/@content-latest?page=${page}`
        : `${baseUrl}/@content-latest`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar conteúdo mais recente: ${response.status}`,
      );
    }

    const data = await response.json();
    return normalizeLatestContent(data);
  } catch (error) {
    console.error('Falha ao buscar conteúdo mais recente:', error);
    return [];
  }
}
